export enum Tables {
  waitlist = 'waitlist',
  reservations = 'reservations',
  togo = 'togo',
  customers = 'customers',
  history = 'history',
}
